import { render, staticRenderFns } from "./ResourcesBanner.vue?vue&type=template&id=b8f89108&scoped=true"
var script = {}
import style0 from "./ResourcesBanner.vue?vue&type=style&index=0&id=b8f89108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f89108",
  null
  
)

export default component.exports